import Header from './Header';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import OwnerSidebar from './OwnerSidebar';
import OwnerTopBar from './OwnerTopBar';
import i18n from '@/lib/i18n/i18n';
import { useEffect } from 'react';
import { cn } from '@/lib/utils';
import { useIsPlatformOwner } from '@/features/control-plane/hooks/useIsPlatformOwner';

const DefaultLayout = () => {
    const { pathname } = useLocation();
    const isOwner = useIsPlatformOwner();

    useEffect(() => {
        const m = pathname.match(/^\/(ar|en)(?=\/|$)/);
        if (m && m[1]) {
            const urlLang = m[1] as 'ar' | 'en';
            const current = i18n.language?.split('-')[0];
            if (current !== urlLang) {
                i18n.changeLanguage(urlLang).catch((err) => {
                    console.error('Error syncing language from URL:', err);
                });
            }
        }
    }, [pathname]);

    return (
        <main
            className={cn(
                'min-h-screen md:grid md:grid-cols-[auto_1fr]',
                isOwner ? 'owner-shell font-owner bg-[#F8FAFC]' : 'font-cairo',
            )}
        >
            {isOwner ? <OwnerSidebar /> : <Sidebar />}
            <div className="relative flex min-h-screen w-full flex-col">
                {isOwner ? <OwnerTopBar /> : <Header />}
                {isOwner ? (
                    <div className="w-full flex-grow">
                        <Outlet />
                    </div>
                ) : (
                    <div className="custom:w-[1104px] custom:px-0 m-auto w-full flex-grow px-5 lg:px-6">
                        <Outlet />
                    </div>
                )}
            </div>
        </main>
    );
};

export default DefaultLayout;
